import { BehavioralVerb } from 'apps/web/types/labelled-collection.type';
import { createOptions } from 'apps/web/types/option';

// For verbs where value and label are the same
export const STANDARD_REMEMBERING_VERBS: BehavioralVerb[] = createOptions([
  'Cite',
  'Draw',
  'Duplicate',
  'Enumerate',
  'Identifies',
  'Index',
  'Know',
  'Label',
  'List',
  'Name',
  'Recall',
  'Recognize',
  'Reproduce',
  'State',
  'Tabulate',
  'Trace',
]);

export const STANDARD_UNDERSTANDING_VERBS: BehavioralVerb[] = createOptions([
  'Add',
  'Clarify',
  'Classify',
  'Comprehend',
  'Compute',
  'Convert',
  'Describe',
  'Differentiate',
  'Discuss',
  'Distinguish',
  'Estimate',
  'Exemplify',
  'Explain',
  'Extend',
  'Generalize',
  'Give',
  'Give an example',
  'Infer',
  'Rewrite',
  'Translate',
  'Visualize',
]);

export const STANDARD_APPLYING_VERBS: BehavioralVerb[] = createOptions([
  'Acquire',
  'Apply',
  'Calculate',
  'Change',
  'Compute',
  'Construct',
  'Convert',
  'Demonstrate',
  'Discover',
  'Dramatize',
  'Employ',
  'Execute',
  'Illustrate',
  'Manipulate',
  'Modify',
  'Operate',
  'Practice',
  'Prepare',
  'Produce',
  'Relate',
  'Show',
  'Solve',
  'Use',
]);

export const STANDARD_ANALYZING_VERBS: BehavioralVerb[] = createOptions([
  'Analyze',
  'Attribute',
  'Classify',
  'Diagram',
  'Discriminate',
  'Distinguish',
  'Examine',
  'Illustrate',
  'Infer',
  'Organize',
  'Outline',
  'Question',
  'Relate',
  'Separate',
]);

export const STANDARD_EVALUATING_VERBS: BehavioralVerb[] = createOptions([
  'Appraise',
  'Conclude',
  'Coordinate',
  'Critique',
  'Detect',
  'Discriminate',
  'Evaluate',
  'Explain',
  'Justify',
  'Measure',
  'Recommend',
  'Relate',
  'Support',
  'Verify',
]);

export const STANDARD_CREATING_VERBS: BehavioralVerb[] = createOptions([
  'Arrange',
  'Assemble',
  'Combine',
  'Compile',
  'Construct',
  'Explain',
  'Formulate',
  'Generate',
  'Hypothesize',
  'Imagine',
  'Invent',
  'Justify',
  'Modify',
  'Organize',
  'Plan',
  'Produce',
  'Propose',
  'Rearrange',
  'Reconstruct',
  'Relate',
  'Reorganize',
  'Report',
  'Revise',
  'Rewrite',
  'Summarize',
  'Tell',
]);
